export default "__VITE_ASSET__e4c81f07__"